import { ERC20PermitInterface } from '@/configs/abis/ERC20PermitInterface';
import { gateABI } from '@/configs/abis/gate';
import { instrumentABI } from '@/configs/abis/instrument';
import { routerAbi } from '@/configs/abis/router';
import { DAPP_CHAIN_CONFIGS } from '@/constants/chain';
import { Provider } from '@ethersproject/providers';
import { Contract, Signer } from 'ethers';

export function getSynContract({
  chainId,
  type,
  address,
  signerOrProvider,
}:
  | {
      chainId: number;
      type: 'gate' | 'router';
      address?: string;
      signerOrProvider?: Signer | Provider;
    }
  | {
      chainId: number;
      type: 'erc20Permit' | 'instrument';
      address: string;
      signerOrProvider?: Signer | Provider;
    }) {
  if (!address) {
    const dappConfig = DAPP_CHAIN_CONFIGS[chainId];
    if (type === 'gate') {
      const gateAddr = dappConfig?.contracts?.gate;
      if (!gateAddr) {
        throw new Error('Gate contract address not found');
      }
      address = gateAddr;
    } else if (type === 'erc20Permit' || type === 'instrument') {
      if (!address) {
        throw new Error(`${type === 'instrument' ? 'Instrument' : 'ERC20Permit'} contract address not found`);
      }
    } else {
      const routerAddr = dappConfig?.contracts?.router;
      if (!routerAddr) {
        throw new Error('Router contract address not found');
      }
      address = routerAddr;
    }
  }
  return new Contract(
    address,
    type === 'gate'
      ? gateABI
      : type === 'erc20Permit'
      ? ERC20PermitInterface
      : type === 'instrument'
      ? instrumentABI
      : routerAbi,
    signerOrProvider,
  );
}
